export default {
  namespaced: true,
  state: () => ({
    pristine: true,
    settingsVisible: false
  }),
  mutations: {
    touch(state) {
      state.pristine = false
    },
    showSettings(state) {
      state.settingsVisible = true
    },
    hideSettings(state) {
      state.settingsVisible = false
    }
  },
  getters: {
    isPristine(state) {
      return state.pristine
    },
    isSettingsVisible(state) {
      return state.settingsVisible
    }
  }
}
